import { ButtonIcon } from '@tallink/components-lib'
import React from 'react'

import useFormatPrice from '../../../utils/formatPrice'
import MorePropTypes from '../../../utils/MorePropTypes'
import Hint from '../Hint/Hint'
import s from './MobileSerialTicket.module.scss'

export default function MobileSerialTicket({ ticket, plusMinusProps }) {
  const formatPrice = useFormatPrice()
  const { code, price, title, tooltipTitle, tooltipInfo } = ticket
  const { value, decreaseDisabled, increaseDisabled, onDecreaseClick, onIncreaseClick } = plusMinusProps

  return (
    <div id={code}>
      <ButtonIcon
        className={s.button}
        disabled={decreaseDisabled}
        iconSize="original"
        iconType="minus-in-circle-fill"
        onClick={onDecreaseClick}
      />
      <div className={s['text-and-price']}>
        <div className={s.text}>
          <span className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
          {(tooltipTitle || tooltipInfo) && <Hint text={tooltipInfo} title={tooltipTitle} />}
        </div>
        <div className={s.price}>
          {!!value && <span>{value} × </span>} {formatPrice(price)}
        </div>
      </div>
      <ButtonIcon
        className={s.button}
        disabled={increaseDisabled}
        iconSize="original"
        iconType="plus-in-circle-fill"
        onClick={onIncreaseClick}
      />
    </div>
  )
}

MobileSerialTicket.propTypes = {
  plusMinusProps: MorePropTypes.plusMinusMobileProps.isRequired,
  ticket: MorePropTypes.serialTicket.isRequired
}
